import styles from '@/assets/styles/pages/competition/competition.module.scss';
import { MimaText } from '@/components';
import moment from 'moment';

interface CompetitionsProps {
  competitionList: any;
}

const TimeLine: React.FC<CompetitionsProps> = ({ competitionList }) => {
  return (
    <div className={styles.steps}>
      <div className={styles.container}>
        <MimaText variant="h2" align="center" className={styles.titleText}>
          Competition <span>Timeline</span>
        </MimaText>

        <div className={styles.set}>
          <div className={styles.stepsCard}>
            <div className={styles.stepsList}>
              {/* Registration Period */}
              <div className={styles.step}>
                <div className={styles.title}>
                  <div className={styles.icon}></div>
                  <MimaText variant="bodyBold" fontWeight={500} color="var(--color-dark)">
                    Registration Start Date
                  </MimaText>
                </div>
                <div className={styles.details}>
                  <div className={styles.line}>
                    <hr />
                  </div>
                  <MimaText mt={0.8} mb={2.8}>
                    {moment(competitionList?.[0]?.registrationStartDate).format('DD/MM/YYYY HH:mm A')}
                  </MimaText>
                </div>
              </div>
              <div className={styles.step}>
                <div className={styles.title}>
                  <div className={styles.icon}></div>
                  <MimaText variant="bodyBold" color="var(--color-dark)">
                    Registration End Date
                  </MimaText>
                </div>
                <div className={styles.details}>
                  <div className={styles.line}>
                    <hr />
                  </div>
                  <MimaText mt={0.8} mb={2.8}>
                    {moment(competitionList?.[0]?.registrationEndDate).format('DD/MM/YYYY HH:mm A')}
                  </MimaText>
                </div>
              </div>

              {/* Stage One Voting Period */}
              <div className={styles.step}>
                <div className={styles.title}>
                  <div className={styles.icon}></div>
                  <MimaText variant="bodyBold" color="var(--color-dark)">
                    Stage One Voting Start Date
                  </MimaText>
                </div>
                <div className={styles.details}>
                  <div className={styles.line}>
                    <hr />
                  </div>
                  <MimaText mt={0.8} mb={2.8}>
                    {moment(competitionList?.[0]?.stageOneVotingStartDate).format('DD/MM/YYYY HH:mm A')}
                  </MimaText>
                </div>
              </div>
              <div className={styles.step}>
                <div className={styles.title}>
                  <div className={styles.icon}></div>
                  <MimaText variant="bodyBold" color="var(--color-dark)">
                    Stage One Voting End Date
                  </MimaText>
                </div>
                <div className={styles.details}>
                  <div className={styles.line}>
                    <hr />
                  </div>
                  <MimaText mt={0.8} mb={2.8}>
                    {moment(competitionList?.[0]?.stageOneVotingEndDate).format('DD/MM/YYYY HH:mm A')}
                  </MimaText>
                </div>
              </div>

              {/* Stage Two Voting Period */}
              <div className={styles.step}>
                <div className={styles.title}>
                  <div className={styles.icon}></div>
                  <MimaText variant="bodyBold" color="var(--color-dark)">
                    Stage Two Voting Start Date
                  </MimaText>
                </div>
                <div className={styles.details}>
                  <div className={styles.line}>
                    <hr />
                  </div>
                  <MimaText mt={0.8} mb={2.8}>
                    {moment(competitionList?.[0]?.stageTwoVotingStartDate).format('DD/MM/YYYY HH:mm A')}
                  </MimaText>
                </div>
              </div>
              <div className={styles.lastStep}>
                <div className={styles.title}>
                  <div className={styles.icon}></div>
                  <MimaText variant="bodyBold" color="var(--color-dark)">
                    Stage Two Voting End Date
                  </MimaText>
                </div>
                <div className={styles.details}>
                  <div className={styles.line}>
                    <hr />
                  </div>
                  <MimaText mt={0.8} mb={2.8}>
                    {moment(competitionList?.[0]?.stageTwoVotingEndDate).format('DD/MM/YYYY HH:mm A')}
                  </MimaText>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimeLine;

// import styles from '@/assets/styles/pages/competition/competition.module.scss';
// import { MimaText, FashButton, MimaButton } from '@/components';
// import { SiGnuprivacyguard } from 'react-icons/si';
// import constant from '@/utils/constant';
// import Link from 'next/link';
// import { useSwitchNav } from '@/components/PageLayout/_PageLayoutComponents/SwitchNav';
// import { amountFormatter, isDateWithinRange } from '@/utils/utils';
// import { competitionStore } from '@/stores';
// import moment from 'moment';

// interface CompetitionsProps {
//   competitionList: any;
// }

// const TimeLine: React.FC<CompetitionsProps> = ({ competitionList }) => {
//   console.log('competitionList', competitionList);
//   return (
//     <section className={styles.timeline}>
//       <MimaText variant="h3" align="center" mb={2}>
//         Competition Timeline
//       </MimaText>
//       <div className={styles.container}>
//         <div className={styles.container_event}>
//           <div>
//             <MimaText variant="subtitleBold" color="var(--color-dark)">
//               Registration Start Date
//             </MimaText>
//             <MimaText>{moment(competitionList?.[0]?.registrationStartDate).format('DD/MM/YYYY')}</MimaText>
//           </div>
//           <div>
//             <MimaText variant="subtitleBold" color="var(--color-dark)">
//               Registration End Date
//             </MimaText>
//             <MimaText>{moment(competitionList?.[0]?.registrationEndDate).format('DD/MM/YYYY')}</MimaText>
//           </div>
//         </div>
//         <div className={styles.container_event}>
//           <div>
//             <MimaText variant="subtitleBold" color="var(--color-dark)">
//               Stage One Voting Start Date
//             </MimaText>
//             <MimaText>{moment(competitionList?.[0]?.stageOneVotingStartDate).format('DD/MM/YYYY')}</MimaText>
//           </div>
//           <div>
//             <MimaText variant="subtitleBold" color="var(--color-dark)">
//               Stage One Voting End Date
//             </MimaText>
//             <MimaText>{moment(competitionList?.[0]?.stageOneVotingEndDate).format('DD/MM/YYYY')}</MimaText>
//           </div>
//         </div>
//         <div className={styles.container_event}>
//           <div>
//             <MimaText variant="subtitleBold" color="var(--color-dark)">
//               Stage Two Voting Start Date
//             </MimaText>
//             <MimaText>{moment(competitionList?.[0]?.stageTwoVotingStartDate).format('DD/MM/YYYY')}</MimaText>
//           </div>
//           <div>
//             <MimaText variant="subtitleBold" color="var(--color-dark)">
//               Stage Two Voting End Date
//             </MimaText>
//             <MimaText>{moment(competitionList?.[0]?.stageTwoVotingEndDate).format('DD/MM/YYYY')}</MimaText>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default TimeLine;
